export const defaultComponentApprove = () => {
    return {};
};

export const defaultComponentApprovedList = () => {
    return [];
};

export default {
    tiposCas: [],
    listaControles: [
        {
            id: 1,
            type: "select_multiple",
            label: "Select Multiple",
        },
        {
            id: 2,
            type: "checkbox",
            label: "Checkbox",
        },
        {
            id: 3,
            type: "select",
            label: "Select Unico",
        },
        {
            id: 4,
            type: "year",
            label: "Año",
        },
        {
            id: 5,
            type: "number",
            label: "Numero Entero",
        },
        {
            id: 6,
            type: "float",
            label: "Numero Decimal",
        },
        {
            id: 7,
            type: "text",
            label: "Texto",
        },
    ],
    controles: [],
    componentes: [],
    parametrosBuscador: {
        peligro_id: "",
        buscar: "",
        page: 1,
        perPage: 10,
        sortBy: "id",
        sort: "DESC",
    },
    componentesPeligro: [],
    valoresComponente: [],
    todosLoscomponentes: [],
    parametrosBuscadorComponente: {
        buscar: "",
        cas_family: null,
        page: 1,
        perPage: 10,
        sortBy: "id",
        sort: "DESC",
    },
    componente: {},
    componentesProducto: [],
    formComponente: {
        visible: 1,
        percentaje_symbol_from: "=",
        percentaje_symbol_until: "",
        percentaje_range: 0,
        subproduct: 0,
        prod_attachment_id: "",
    },
    componentesProductoPeligro: [],
    modal_producto_componente: { ver: false },
    componentApprove: defaultComponentApprove,
    componentApprovedList: defaultComponentApprovedList,
    currentDangerActive: null,
    responseUpFileExcelComponents: null
};
